// apps/portal/lib/database/DatabaseManager.client.ts
import { createBrowserClient } from "@supabase/ssr";
import { SupabaseClient, SupabaseClientOptions } from "@supabase/supabase-js";

export class DatabaseManager {
  /**
   * Create a browser-side Supabase client that uses a PKCE flow and
   * stores the PKCE code_verifier in localStorage so every tab can see it.
   */
  static createBrowserClient(): SupabaseClient {
    const options: SupabaseClientOptions<"public"> = {
      auth: {
        flowType: "pkce",
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
      },
    };

    // ── Browser-only: supply a localStorage adapter that meets the
    //    { getItem, setItem, removeItem } contract expected by Supabase.
    if (typeof window !== "undefined" && window.localStorage) {
      const sharedTabStorage = {
        getItem: (key: string) =>
          Promise.resolve(window.localStorage.getItem(key)),
        setItem: (key: string, value: string) => {
          window.localStorage.setItem(key, value);
          return Promise.resolve();
        },
        removeItem: (key: string) => {
          window.localStorage.removeItem(key);
          return Promise.resolve();
        },
      } as const;

      options.auth!.storage = sharedTabStorage;
    }

    return createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      options
    );
  }
}
